import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import history from '@guestyci/history';
import { useOktaAuth } from '@okta/okta-react';

const Logout = () => {
  const { oktaAuth } = useOktaAuth();
  const lang = window.localStorage.getItem('lang');
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const returnTo = queryParams.get('return_to');
  const isZendeskAuthorization = !!queryParams.get('zendeskSso');

  async function handleLogout(authClient) {
    try {
      await authClient.revokeAccessToken();
      await authClient.closeSession();
    } catch (e) {
      if (e.xhr && e.xhr.status === 429) {
        // Too many requests
        console.log('Too many requests');
      }
    }

    window.localStorage.clear();
  }

  useEffect(() => {
    const logout = async () => {
      try {
        await handleLogout(oktaAuth);

        window.localStorage.clear();
        window.sessionStorage.clear();

        if (lang) {
          window.localStorage.setItem('lang', lang);
        }

        if (isZendeskAuthorization) {
          window.location.replace(returnTo);
        } else {
          history.replace({
            pathname: 'login',
            search: window.location.search,
          });
        }
      } catch (e) {
        console.log(e);
      }
    };

    logout();
  }, []);

  return null;
};

export default Logout;
